import store from '../store'
const language = store.getters.lang
// 完整的国际区号数据（含验证规则）
export const countriesWithValidation = [
  // 🌏 亚洲 (Asia)
  { 
    name: language.China, 
    code: '+86', 
    emoji: '🇨🇳', 
    pattern: /^1[3-9]\d{9}$/
  },
  { 
    name: language.HongKong, 
    code: '+852', 
    emoji: '🇭🇰', 
    pattern: /^[2-9]\d{7}$/
  },
  { 
    name: language.Macao, 
    code: '+853', 
    emoji: '🇲🇴', 
    pattern: /^[2-9]\d{7}$/
  },
  { 
    name: language.Taiwan, 
    code: '+886', 
    emoji: '🇹🇼', 
    pattern: /^09\d{8}$/
  },
  { 
    name: language.Japan, 
    code: '+81', 
    emoji: '🇯🇵', 
    pattern: /^0[789]0\d{8}$/
  },
  { 
    name: language.SouthKorea, 
    code: '+82', 
    emoji: '🇰🇷', 
    pattern: /^01[016-9]\d{7,8}$/
  },
  { 
    name: language.NorthKorea, 
    code: '+850', 
    emoji: '🇰🇵', 
    pattern: /^01\d{6,7}$/
  },
  { 
    name: language.Mongolia, 
    code: '+976', 
    emoji: '🇲🇳', 
    pattern: /^[89]\d{7}$/
  },
  { 
    name: language.India, 
    code: '+91', 
    emoji: '🇮🇳', 
    pattern: /^[6-9]\d{9}$/
  },
  { 
    name: language.Indonesia, 
    code: '+62', 
    emoji: '🇮🇩', 
    pattern: /^[1-9]\d{9,11}$/
  },
  { 
    name: language.Malaysia, 
    code: '+60', 
    emoji: '🇲🇾', 
    pattern: /^1[0-46-9]\d{7,8}$/
  },
  { 
    name: language.Singapore, 
    code: '+65', 
    emoji: '🇸🇬', 
    pattern: /^[89]\d{7}$/
  },
  { 
    name: language.Thailand, 
    code: '+66', 
    emoji: '🇹🇭', 
    pattern: /^[689]\d{8}$/
  },
  { 
    name: language.Vietnam, 
    code: '+84', 
    emoji: '🇻🇳', 
    pattern: /^[3-9]\d{8}$/
  },
  { 
    name: language.Philippines, 
    code: '+63', 
    emoji: '🇵🇭', 
    pattern: /^[89]\d{9}$/
  },
  { 
    name: language.Myanmar, 
    code: '+95', 
    emoji: '🇲🇲', 
    pattern: /^[79]\d{8,9}$/
  },
  { 
    name: language.Cambodia, 
    code: '+855', 
    emoji: '🇰🇭', 
    pattern: /^[1-9]\d{8}$/
  },
  { 
    name: language.Laos, 
    code: '+856', 
    emoji: '🇱🇦', 
    pattern: /^20\d{8}$/
  },
  { 
    name: language.Brunei, 
    code: '+673', 
    emoji: '🇧🇳', 
    pattern: /^[7-8]\d{6}$/
  },
  { 
    name: language.TimorLeste, 
    code: '+670', 
    emoji: '🇹🇱', 
    pattern: /^[7-8]\d{6,7}$/
  },
  { 
    name: language.Nepal, 
    code: '+977', 
    emoji: '🇳🇵', 
    pattern: /^9\d{9}$/
  },
  { 
    name: language.Bhutan, 
    code: '+975', 
    emoji: '🇧🇹', 
    pattern: /^[17]\d{7}$/
  },
  { 
    name: language.Bangladesh, 
    code: '+880', 
    emoji: '🇧🇩', 
    pattern: /^1[3-9]\d{8}$/
  },
  { 
    name: language.Pakistan, 
    code: '+92', 
    emoji: '🇵🇰', 
    pattern: /^3\d{9}$/
  },
  { 
    name: language.SriLanka, 
    code: '+94', 
    emoji: '🇱🇰', 
    pattern: /^7\d{8}$/
  },
  { 
    name: language.Maldives, 
    code: '+960', 
    emoji: '🇲🇻', 
    pattern: /^[7-9]\d{6}$/
  },
  { 
    name: language.Kazakhstan, 
    code: '+7', 
    emoji: '🇰🇿', 
    pattern: /^7\d{9}$/
  },
  { 
    name: language.Kyrgyzstan, 
    code: '+996', 
    emoji: '🇰🇬', 
    pattern: /^[5-7]\d{8}$/
  },
  { 
    name: language.Tajikistan, 
    code: '+992', 
    emoji: '🇹🇯', 
    pattern: /^[9]\d{8}$/
  },
  { 
    name: language.Uzbekistan, 
    code: '+998', 
    emoji: '🇺🇿', 
    pattern: /^[9]\d{8}$/
  },
  { 
    name: language.Turkmenistan, 
    code: '+993', 
    emoji: '🇹🇲', 
    pattern: /^[6-8]\d{7}$/
  },
  { 
    name: language.Afghanistan, 
    code: '+93', 
    emoji: '🇦🇫', 
    pattern: /^[7]\d{8}$/
  },
  { 
    name: language.Iran, 
    code: '+98', 
    emoji: '🇮🇷', 
    pattern: /^9\d{9}$/
  },
  { 
    name: language.Iraq, 
    code: '+964', 
    emoji: '🇮🇶', 
    pattern: /^[7]\d{9}$/
  },
  { 
    name: language.Kuwait, 
    code: '+965', 
    emoji: '🇰🇼', 
    pattern: /^[5-9]\d{7}$/
  },
  { 
    name: language.SaudiArabia, 
    code: '+966', 
    emoji: '🇸🇦', 
    pattern: /^5\d{8}$/
  },
  { 
    name: language.Yemen, 
    code: '+967', 
    emoji: '🇾🇪', 
    pattern: /^7\d{8}$/
  },
  { 
    name: language.Oman, 
    code: '+968', 
    emoji: '🇴🇲', 
    pattern: /^[9]\d{7}$/
  },
  { 
    name: language.UnitedArabEmirates, 
    code: '+971', 
    emoji: '🇦🇪', 
    pattern: /^5\d{8}$/
  },
  { 
    name: language.Qatar, 
    code: '+974', 
    emoji: '🇶🇦', 
    pattern: /^[3-7]\d{7}$/
  },
  { 
    name: language.Bahrain, 
    code: '+973', 
    emoji: '🇧🇭', 
    pattern: /^[3-9]\d{7}$/
  },
  { 
    name: language.Lebanon, 
    code: '+961', 
    emoji: '🇱🇧', 
    pattern: /^[3-7]\d{6,7}$/
  },
  { 
    name: language.Jordan, 
    code: '+962', 
    emoji: '🇯🇴', 
    pattern: /^7\d{8}$/
  },
  { 
    name: language.Syria, 
    code: '+963', 
    emoji: '🇸🇾', 
    pattern: /^9\d{8}$/
  },
  { 
    name: language.Israel, 
    code: '+972', 
    emoji: '🇮🇱', 
    pattern: /^5\d{8}$/
  },
  { 
    name: language.Palestine, 
    code: '+970', 
    emoji: '🇵🇸', 
    pattern: /^5\d{8}$/
  },
  { 
    name: language.Cyprus, 
    code: '+357', 
    emoji: '🇨🇾', 
    pattern: /^9\d{7}$/
  },
  { 
    name: language.tuerqi, 
    code: '+90', 
    emoji: '🇹🇷', 
    pattern: /^5\d{9}$/
  },
  { 
    name: language.Azerbaijan, 
    code: '+994', 
    emoji: '🇦🇿', 
    pattern: /^[5-7]\d{8}$/
  },
  { 
    name: language.Georgia, 
    code: '+995', 
    emoji: '🇬🇪', 
    pattern: /^5\d{8}$/
  },
  { 
    name: language.Armenia, 
    code: '+374', 
    emoji: '🇦🇲', 
    pattern: /^[9]\d{7}$/
  },

  // 🌍 欧洲 (Europe)
  { 
    name: language.Russia, 
    code: '+7', 
    emoji: '🇷🇺', 
    pattern: /^9\d{9}$/
  },
  { 
    name: language.Germany, 
    code: '+49', 
    emoji: '🇩🇪', 
    pattern: /^1[5-7]\d{8,9}$/
  },
  { 
    name: language.France, 
    code: '+33', 
    emoji: '🇫🇷', 
    pattern: /^[6-7]\d{8}$/
  },
  { 
    name: language.Britain, 
    code: '+44', 
    emoji: '🇬🇧', 
    pattern: /^7\d{9}$/
  },
  { 
    name: language.Italy, 
    code: '+39', 
    emoji: '🇮🇹', 
    pattern: /^3\d{8,9}$/
  },
  { 
    name: language.Spain, 
    code: '+34', 
    emoji: '🇪🇸', 
    pattern: /^[6-7]\d{8}$/
  },
  { 
    name: language.Portugal, 
    code: '+351', 
    emoji: '🇵🇹', 
    pattern: /^9\d{8}$/
  },
  { 
    name: language.Netherlands, 
    code: '+31', 
    emoji: '🇳🇱', 
    pattern: /^6\d{8}$/
  },
  { 
    name: language.Belgium, 
    code: '+32', 
    emoji: '🇧🇪', 
    pattern: /^4\d{8}$/
  },
  { 
    name: language.Austria, 
    code: '+43', 
    emoji: '🇦🇹', 
    pattern: /^6\d{10}$/
  },
  { 
    name: language.Switzerland, 
    code: '+41', 
    emoji: '🇨🇭', 
    pattern: /^7[2-9]\d{7}$/
  },
  { 
    name: language.Sweden, 
    code: '+46', 
    emoji: '🇸🇪', 
    pattern: /^7\d{8}$/
  },
  { 
    name: language.Norway, 
    code: '+47', 
    emoji: '🇳🇴', 
    pattern: /^4\d{7}$/
  },
  { 
    name: language.Denmark, 
    code: '+45', 
    emoji: '🇩🇰', 
    pattern: /^[2-9]\d{7}$/
  },
  { 
    name: language.Finland, 
    code: '+358', 
    emoji: '🇫🇮', 
    pattern: /^4\d{7,8}$/
  },
  { 
    name: language.Iceland, 
    code: '+354', 
    emoji: '🇮🇸', 
    pattern: /^[6-9]\d{6}$/
  },
  { 
    name: language.Ireland, 
    code: '+353', 
    emoji: '🇮🇪', 
    pattern: /^8[3-9]\d{7}$/
  },
  { 
    name: language.Poland, 
    code: '+48', 
    emoji: '🇵🇱', 
    pattern: /^5\d{8}$/
  },
  { 
    name: language.Czech, 
    code: '+420', 
    emoji: '🇨🇿', 
    pattern: /^[6-7]\d{8}$/
  },
  { 
    name: language.Slovakia, 
    code: '+421', 
    emoji: '🇸🇰', 
    pattern: /^9\d{8}$/
  },
  { 
    name: language.Hungary, 
    code: '+36', 
    emoji: '🇭🇺', 
    pattern: /^[2-9]\d{8}$/
  },
  { 
    name: language.Romania, 
    code: '+40', 
    emoji: '🇷🇴', 
    pattern: /^7\d{8}$/
  },
  { 
    name: language.Bulgaria, 
    code: '+359', 
    emoji: '🇧🇬', 
    pattern: /^[8-9]\d{7}$/
  },
  { 
    name: language.Serbia, 
    code: '+381', 
    emoji: '🇷🇸', 
    pattern: /^6\d{7,8}$/
  },
  { 
    name: language.Croatia, 
    code: '+385', 
    emoji: '🇭🇷', 
    pattern: /^9\d{7,8}$/
  },
  { 
    name: language.Slovenia, 
    code: '+386', 
    emoji: '🇸🇮', 
    pattern: /^[3-7]\d{7}$/
  },
  { 
    name: language.BosniaHerzegovina, 
    code: '+387', 
    emoji: '🇧🇦', 
    pattern: /^6\d{7}$/
  },
  { 
    name: language.NorthMacedonia, 
    code: '+389', 
    emoji: '🇲🇰', 
    pattern: /^7\d{7}$/
  },
  { 
    name: language.Albania, 
    code: '+355', 
    emoji: '🇦🇱', 
    pattern: /^6[6-9]\d{7}$/
  },
  { 
    name: language.Greece, 
    code: '+30', 
    emoji: '🇬🇷', 
    pattern: /^6\d{8}$/
  },
  { 
    name: language.Malta, 
    code: '+356', 
    emoji: '🇲🇹', 
    pattern: /^[7-9]\d{7}$/
  },
  { 
    name: language.Luxembourg, 
    code: '+352', 
    emoji: '🇱🇺', 
    pattern: /^6[2-9]\d{7}$/
  },
  { 
    name: language.Monaco, 
    code: '+377', 
    emoji: '🇲🇨', 
    pattern: /^[4-6]\d{7}$/
  },
  { 
    name: language.Liechtenstein, 
    code: '+423', 
    emoji: '🇱🇮', 
    pattern: /^7\d{6,7}$/
  },
  { 
    name: language.Andorra, 
    code: '+376', 
    emoji: '🇦🇩', 
    pattern: /^[3-6]\d{5}$/
  },
  { 
    name: language.SanMarino, 
    code: '+378', 
    emoji: '🇸🇲', 
    pattern: /^[3-6]\d{5}$/
  },
  { 
    name: language.Vatican, 
    code: '+379', 
    emoji: '🇻🇦', 
    pattern: /^3\d{7}$/
  },
  { 
    name: language.Ukraine, 
    code: '+380', 
    emoji: '🇺🇦', 
    pattern: /^[6-9]\d{8}$/
  },
  { 
    name: language.Belarus, 
    code: '+375', 
    emoji: '🇧🇾', 
    pattern: /^[2-9]\d{8}$/
  },
  { 
    name: language.Moldova, 
    code: '+373', 
    emoji: '🇲🇩', 
    pattern: /^6\d{7}$/
  },
  { 
    name: language.Lithuania, 
    code: '+370', 
    emoji: '🇱🇹', 
    pattern: /^6\d{7}$/
  },
  { 
    name: language.Latvia, 
    code: '+371', 
    emoji: '🇱🇻', 
    pattern: /^2\d{7}$/
  },
  { 
    name: language.Estonia, 
    code: '+372', 
    emoji: '🇪🇪', 
    pattern: /^5\d{6,7}$/
  },

  // 🌎 北美洲 (North America)
  { 
    name: language.UnitedStates, 
    code: '+1', 
    emoji: '🇺🇸', 
    pattern: /^[2-9]\d{2}[2-9]\d{6}$/
  },
  { 
    name: language.Canada, 
    code: '+1', 
    emoji: '🇨🇦', 
    pattern: /^[2-9]\d{2}[2-9]\d{6}$/
  },
  { 
    name: language.Mexico, 
    code: '+52', 
    emoji: '🇲🇽', 
    pattern: /^1?\d{10}$/
  },
  { 
    name: language.Greenland, 
    code: '+299', 
    emoji: '🇬🇱', 
    pattern: /^[2-9]\d{5}$/
  },

  // 加勒比海地区（简化版，主要国家）
  { 
    name: language.Cuba, 
    code: '+53', 
    emoji: '🇨🇺', 
    pattern: /^5\d{7}$/
  },
  { 
    name: language.Jamaica, 
    code: '+1-876', 
    emoji: '🇯🇲', 
    pattern: /^[2-9]\d{9}$/
  },
  { 
    name: language.Haiti, 
    code: '+509', 
    emoji: '🇭🇹', 
    pattern: /^[34]\d{7}$/
  },
  { 
    name: language.DominicanRepublic, 
    code: '+1-809', 
    emoji: '🇩🇴', 
    pattern: /^[2-9]\d{9}$/
  },
  { 
    name: language.PuertoRico, 
    code: '+1-787', 
    emoji: '🇵🇷', 
    pattern: /^[2-9]\d{9}$/
  },

  // 中美洲
  { 
    name: language.CostaRica, 
    code: '+506', 
    emoji: '🇨🇷', 
    pattern: /^[6-8]\d{7}$/
  },
  { 
    name: language.Panama, 
    code: '+507', 
    emoji: '🇵🇦', 
    pattern: /^[6-8]\d{7}$/
  },

  // 🌎 南美洲 (South America)
  { 
    name: language.Argentina, 
    code: '+54', 
    emoji: '🇦🇷', 
    pattern: /^9?\d{10}$/
  },
  { 
    name: language.Bolivia, 
    code: '+591', 
    emoji: '🇧🇴', 
    pattern: /^[67]\d{7}$/
  },
  { 
    name: language.Brazil, 
    code: '+55', 
    emoji: '🇧🇷', 
    pattern: /^1[1-9]\d{8,9}$/
  },
  { 
    name: language.Chile, 
    code: '+56', 
    emoji: '🇨🇱', 
    pattern: /^9\d{8}$/
  },
  { 
    name: language.Colombia, 
    code: '+57', 
    emoji: '🇨🇴', 
    pattern: /^3\d{9}$/
  },
  { 
    name: language.Ecuador, 
    code: '+593', 
    emoji: '🇪🇨', 
    pattern: /^9\d{8}$/
  },
  { 
    name: language.Paraguay, 
    code: '+595', 
    emoji: '🇵🇾', 
    pattern: /^9\d{8}$/
  },
  { 
    name: language.Peru, 
    code: '+51', 
    emoji: '🇵🇪', 
    pattern: /^9\d{8}$/
  },
  { 
    name: language.Uruguay, 
    code: '+598', 
    emoji: '🇺🇾', 
    pattern: /^9\d{7}$/
  },
  { 
    name: language.Venezuela, 
    code: '+58', 
    emoji: '🇻🇪', 
    pattern: /^4\d{9}$/
  },

  // 🌍 非洲 (Africa) - 主要国家
  { 
    name: language.Egypt, 
    code: '+20', 
    emoji: '🇪🇬', 
    pattern: /^1[0-2]\d{8}$/
  },
  { 
    name: language.SouthAfrica, 
    code: '+27', 
    emoji: '🇿🇦', 
    pattern: /^[6-8]\d{8}$/
  },
  { 
    name: language.Morocco, 
    code: '+212', 
    emoji: '🇲🇦', 
    pattern: /^[6-7]\d{8}$/
  },
  { 
    name: language.Algeria, 
    code: '+213', 
    emoji: '🇩🇿', 
    pattern: /^[5-6]\d{8}$/
  },
  { 
    name: language.Tunisia, 
    code: '+216', 
    emoji: '🇹🇳', 
    pattern: /^[2-9]\d{7}$/
  },
  { 
    name: language.Nigeria, 
    code: '+234', 
    emoji: '🇳🇬', 
    pattern: /^[7-9]\d{9}$/
  },
  { 
    name: language.Kenya, 
    code: '+254', 
    emoji: '🇰🇪', 
    pattern: /^[7]\d{8}$/,
  },
  { 
    name: language.Ghana, 
    code: '+233', 
    emoji: '🇬🇭', 
    pattern: /^[2-5]\d{8}$/,
  },
  { 
    name: language.Angola, 
    code: '+244', 
    emoji: '🇦🇴', 
    pattern: /^[9]\d{8}$/,
  },
  { 
    name: language.Ethiopia, 
    code: '+251', 
    emoji: '🇪🇹', 
    pattern: /^9\d{8}$/,
  },
  { 
    name: language.Tanzania, 
    code: '+255', 
    emoji: '🇹🇿', 
    pattern: /^[6-7]\d{8}$/,
  },
  { 
    name: language.Uganda, 
    code: '+256', 
    emoji: '🇺🇬', 
    pattern: /^7\d{8}$/,
  },
  { 
    name: language.Sudan, 
    code: '+249', 
    emoji: '🇸🇩', 
    pattern: /^9\d{8}$/,
  },
  { 
    name: language.Rwanda, 
    code: '+250', 
    emoji: '🇷🇼', 
    pattern: /^7\d{8}$/,
  },
  { 
    name: language.Cameroon, 
    code: '+237', 
    emoji: '🇨🇲', 
    pattern: /^[6-8]\d{8}$/,
  },
  { 
    name: language.IvoryCoast, 
    code: '+225', 
    emoji: '🇨🇮', 
    pattern: /^[0-5]\d{7}$/,
  },
  { 
    name: language.Zimbabwe, 
    code: '+263', 
    emoji: '🇿🇼', 
    pattern: /^7\d{8}$/,
  },
  { 
    name: language.Zambia, 
    code: '+260', 
    emoji: '🇿🇲', 
    pattern: /^9\d{8}$/,
  },

  // 🌏 大洋洲 (Oceania)
  { 
    name: language.Australia, 
    code: '+61', 
    emoji: '🇦🇺', 
    pattern: /^4\d{8}$/,
  },
  { 
    name: language.NewZealand, 
    code: '+64', 
    emoji: '🇳🇿', 
    pattern: /^2\d{8,9}$/,
  },
  { 
    name: language.PapuaNewGuinea, 
    code: '+675', 
    emoji: '🇵🇬', 
    pattern: /^7\d{7}$/,
  },
  { 
    name: language.Fiji, 
    code: '+679', 
    emoji: '🇫🇯', 
    pattern: /^[5-9]\d{6}$/,
  },
  { 
    name: language.SolomonIslands, 
    code: '+677', 
    emoji: '🇸🇧', 
    pattern: /^[7-8]\d{6}$/,
  }
];
